class IoceaWishList 
{
    createAnAccount (userId)
    {
        if (this.retrieveAccountInformationLocally() == null)
        {
            var wishListContext = this; 

            var postData = 
            {
                UserId: userId
            }

            $.ajax({
                url: IOCEA_WISHLIST_API_URL + '/api/WishList/',
                method: 'POST',
                headers: 
                {
                    "Content-Type": "application/json"
                },
                data: JSON.stringify(postData),
                success: function (response)
                {
                    wishListContext.storeAccountInformationLocally(response['id'], response['userId']);
                }
            })
            .fail (function (response)
                {
                    // try to get and set existing account
                    wishListContext.getWishListAccount(userId);
                }
            );
        }
    }

    storeAccountInformationLocally (accountId, userId)
    {
        var localAccount = 
        {
            account_id : accountId,
            user_id: userId
        }

        localStorage.setItem('iocea_wishlist_account', JSON.stringify(localAccount));

    }

    retrieveAccountInformationLocally ()
    {
        var ls = localStorage.getItem('iocea_wishlist_account');
        return (ls !== null ? JSON.parse(ls) : null);
    }

    getWishListAccount (userId)
    {
        var wishListContext = this; 

        $.ajax({
            url: IOCEA_WISHLIST_API_URL + '/api/WishList/' + userId,
            method: 'GET',
            headers: 
            {
                "Content-Type": "application/json"
            },
            success: function (response)
            {
                wishListContext.storeAccountInformationLocally(response['id'], response['userId']);
            }
        });
    }

    populateWishList (userId) 
    {
        var wishListContext = this; 

        // show loading spinner until response from server
        $(WISH_LIST_CLASS).find('tbody').append('<tr><td colspan="4" style="font-size: 30pt; text-align:center"><i class="fas fa-circle-notch fa-spin"></i></td></tr>');

        $.ajax({
            url: IOCEA_WISHLIST_API_URL + '/api/WishList/' + userId,
            method: 'GET',
            headers: 
            {
                "Content-Type": "application/json"
            },
            success: function (response)
            {
                $(WISH_LIST_CLASS).find('tbody').empty();

                $.each(response['wishListItems'], function(key, wishListItem){
                    var productLink = "window.location.href='"+wishListItem['productUri']+"?variant="+wishListItem['variantId']+"'"; 
                    $(WISH_LIST_CLASS).find('tbody').append('\
                        <tr>\
                            <td><img src="' + wishListItem['image'] + '" style="max-width: 100%"></td>\
                            <td><a href="'+wishListItem['productUri']+"?variant="+wishListItem['variantId']+'">' + wishListItem['productName'] + '</a><br><br><button class="btn btn--secondary btn--small type="button" onclick="addProductToCart('+wishListItem['productId']+', '+wishListItem['variantId']+', \''+wishListItem['productCode']+'\')">Add to Cart</button>\                            </td>\
                            <td>' + wishListContext.formatPenniesToPoundsWithCurrencySymbol(wishListItem['price']) + ' </td>>\
                            <td>\
                                <button class="remove_wishlist_item_button" style="display: block; margin: 0 auto" type="button" onclick="ioceaWishList.removeWishListItem('+wishListItem['id']+')"><i class="far fa-trash-alt"></i></button>\
                            </td>\
                        </tr>\
                    ');
                });

                if (response['wishListItems'].length == 0)
                {
                    $(WISH_LIST_CLASS).find('tbody').append('<tr><td colspan="4" style="text-align:center">There are currently no items in your wishlist.</td></tr>');
                }
            }
        });
    }

    addItemToWishList (button)
    {
        var wishListContext = this; 

        var account = this.retrieveAccountInformationLocally(); 

        var postData = 
        {
            productId: String($(button).data('product-id')),
            variantId: String($(button).data('product-variant-id')),
            productCode: String($(button).data('product-code')),
            productUri: $(button).data('product-uri'),
            productName: $(button).data('product-name'),
            image: $(button).data('product-image'),
            price: $(button).data('product-price')
        }

        $.ajax({
            url: IOCEA_WISHLIST_API_URL + '/api/WishListItem?userId=' + account['user_id'],
            method: 'POST',
            headers: 
            {
                "Content-Type": "application/json"
            },
            data: JSON.stringify(postData),
            success: function (response)
            {
                $('#added-success-message').show();
            }
        });
    }

    removeWishListItem (wishlistItemId)
    {
        var confirmBox = confirm("Are you sure you want to remove this item from your wishlist?");
        if (!confirmBox) return;

        var wishListContext = this; 
        var account = this.retrieveAccountInformationLocally(); 
        
        $.ajax({
            url: IOCEA_WISHLIST_API_URL + '/api/WishListItem/' + account['user_id'] + '/' + wishlistItemId,
            method: 'DELETE',
            headers: 
            {
                "Content-Type": "application/json"
            },
            success: function (response)
            {
                wishListContext.populateWishList(account['user_id']);
            }
        });
    }

    deleteWishList ()
    {

    }

    formatPenniesToPoundsWithCurrencySymbol (pennies)
    {
        return String("&pound;" + pennies/100); 
    }
}